import { render, staticRenderFns } from "./customerVendorRating.vue?vue&type=template&id=70ed0a9c&"
import script from "./customerVendorRating.vue?vue&type=script&lang=js&"
export * from "./customerVendorRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ed0a9c')) {
      api.createRecord('70ed0a9c', component.options)
    } else {
      api.reload('70ed0a9c', component.options)
    }
    module.hot.accept("./customerVendorRating.vue?vue&type=template&id=70ed0a9c&", function () {
      api.rerender('70ed0a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/customerVendorRating.vue"
export default component.exports